export const B2B_CART = 'B2B_CART';
export function setCart(Cart) {
  return {
    type: B2B_CART,
    payload: Cart
  }
}